const AgreementCheckbox = ({ checked, onChange, error }) => (
  <div className="registration-form__field">
    <label className="registration-form__checkbox-label">
      <input
        type="checkbox"
        name="agreement"
        checked={checked}
        onChange={onChange}
      />
      Tôi đồng ý cung cấp thông tin để được tư vấn về các chương trình đào tạo
      tại Học viện Design24.
    </label>
    {error && <div className="error">{error}</div>}
  </div>
);

export default AgreementCheckbox;
